import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { Icon, tip } from '@wordpress/icons';
/**
 * @typedef Props
 * @property {import('react').ReactNode} children Children to render in the tip.
 */

/**
 * @param {Props} props
 * @return {JSX.Element} Element
 */

function Tip(props) {
  return createElement("div", {
    className: "components-tip"
  }, createElement(Icon, {
    icon: tip
  }), createElement("p", null, props.children));
}

export default Tip;
//# sourceMappingURL=index.js.map